import { minutesToMilliseconds } from "date-fns";

import {
	type GetEmployeeMeetingStatsParams,
	getEmployeeMeetingStatsSearch,
} from "../../../api/services/defs/internal-api";

export const employeeMeetingStatsSearchQuery = (params: GetEmployeeMeetingStatsParams) => ({
	queryKey: ["get-employee-meeting-stats-search", params],
	queryFn: () => getEmployeeMeetingStatsSearch(params),
	staleTime: minutesToMilliseconds(2),
	meta: {
		errorMessage: "There was an error getting meeting coverage.",
	},
});
